import { Inject, Injectable } from "@angular/core";
import { FormatterService } from "./formatter.service";
import { DatePipe } from "@angular/common";
import { FormatterServiceConfig } from "@core/formatter/formatter.module";

import PhoneNumber from "awesome-phonenumber";

/**
 * This is the default implementation of the {@link FormatterService} interface. It uses the original Angular 2 pipes for date
 * and number formatting and a custom method fro duration formatting.
 */

@Injectable()
export class FormatterServiceImpl implements FormatterService {

    protected _defaultValues: FormatterServiceConfig = {
      defaultDateFormat: "shortDate",
      defaultDateTimeFormat: "yyyy.MM.dd. H:mm"
    };

    protected _datePipe: DatePipe;

    constructor (
      @Inject(DatePipe) datePipe: DatePipe
    ) {
      this._datePipe = datePipe;
    }

    public formatCardNumber(aNumber: string): string {
      return ("**********" + aNumber.substr(aNumber.length - 6).replace(/[^\dA-Z]/g, "")).replace(/(.{4})/g, "$1 ").trim();
    }

    public formatPhoneNumber(aPhoneNumber: string): string {
      if (!aPhoneNumber) {
        return " ";
      }

      let countryCode, nationalNumber, sMask, last;
      if (aPhoneNumber.indexOf("00") === 0) {
        countryCode = "00";
        nationalNumber = aPhoneNumber.slice(2);
      } else {
        const phoneNumber = new PhoneNumber(aPhoneNumber);
        countryCode = "+" + phoneNumber.getCountryCode();
        nationalNumber = phoneNumber.getNumber( "significant" );
      }

      if (nationalNumber.length % 2 === 0) {
        sMask = nationalNumber.slice(0, nationalNumber.length - 4);
        last = nationalNumber.slice(-4);
      } else {
        sMask = nationalNumber.slice(0, nationalNumber.length - 3);
        last = nationalNumber.slice(-3);
      }
      sMask = sMask.replace(/(\d{2})/mg, "-$&").split("-");
      let sMasked = "";
      for (let i = 1; i < sMask.length; i++) {
        sMasked += "-**";
      }
      return countryCode + sMasked + "-" + last;
    }

    public formatDate(aDate: Date, pattern: string = null): string {
      return this._datePipe.transform(aDate, pattern || this._defaultValues.defaultDateFormat);
    }

    public formatDateTime(aDate: Date, pattern: string = null): string {
      return this._datePipe.transform(aDate, pattern || this._defaultValues.defaultDateTimeFormat);
    }
}
